<template>
    <button type="button" class="d-none" data-toggle="modal" data-target=".createFolderModals" id="addFolderBtn"> </button>
    <div class="modal fade createFolderModals" id="folderModalId" tabindex="-1" role="dialog" aria-hidden="true">
        <div class=" modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <form @submit.prevent="addFolderName" id="createFolder" class="createFolder">
                <div class="modal-header">
                    <h5 class="modal-title">New Folder</h5>
                    <button type="button" class="close" id="closeFolderPop" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="form-group">
                        <input type="text" class="form-control" name="folderName" id="folderName" placeholder="Enter Folder Name" v-model="v$.form.folderName.$model" >
                        <div class="input-errors" v-for="(error, index) of v$.form.folderName.$errors" :key="index">
                            <div class="error-msg">{{ error.$message }}</div>
                        </div> 
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                    <button type="submit" class="btn btn-primary"  :disabled="v$.form.$invalid" v-on:click="addFolderName" v-if="formLoader === 1">Create</button>
                    <button type="button" class="btn btn-primary" :disabled="v$.form.$invalid" v-else><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Loading...</button>
                </div>
                </form> 
            </div>
        </div>
    </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import {
    helpers,
    required,
    minLength
} from '@vuelidate/validators'
import $ from "jquery";
import {
    decodeTextFromBase62,
} from '../../utils/helper.js'

import 
    { postCommon } 
from '../../utils/api.js'

export default {
    name: 'CreateFolderData',
    data() {
        return {
            errorMessage: '',
            formLoader: 1,
            form: {
                folderName: '',
            },
        }
    },
    methods: {
        decodeTextFromBase62,
        async addFolderName() {
            this.formLoader = 2
            let Folderpaths = ''

            let folderName = $('#folderName').val();
            folderName = folderName.trim();

            if (!this.$route.query.path || this.$route.query.path.trim() === '') {
                Folderpaths = folderName;
            }else{
                const pathParam = this.$route.query.path;

                if (pathParam) {
                    const pathSegments = pathParam.split('/');

                    let newUrl = '';
                    let newAxiosUrl = '';
                    for (let i = 0; i < pathSegments.length; i++) {
                        let tempName = this.decodeTextFromBase62(pathSegments[i]);
                        if( i === 0) {
                            newUrl = tempName;
                            newAxiosUrl = tempName;

                        } else{
                            newUrl = newUrl + '/' + tempName
                            newAxiosUrl = newAxiosUrl + '/' + tempName
                        }
                    }
                    Folderpaths = newAxiosUrl;
                } else {
                    Folderpaths = this.decodeTextFromBase62(this.pathParam);
                }

                Folderpaths = Folderpaths+ '/' + folderName;
            }
            
            // axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.$store.state.user.accessToken;

            let _post = {}
            _post = {
                folderName: Folderpaths,
            }
            this.addFolder(_post)
        },
        async addFolder(_post) {
            const resp = await postCommon('files/create-folder', _post)
            if (resp.status == 200 && resp.data.status == 'success') {
                document.getElementById('closeFolderPop').click();
                this.$toast.success(resp.data.message);
                // this.$store.state.home.reLoadFolder = Math.random();
                // this.$store.state.home.reLoadPathFolder = Math.random();
                // this.$store.state.home.reLoadFilecomponent = Math.random();
                this.$store.state.home.reLoadFoldercomponent = Math.random();
            } else if (resp.status == 200 && resp.data.status == 'failure') {
                this.errorMessage = resp.data.message;
                this.$toast.error(resp.data.message);
            }
            this.formLoader = 1
        },
        async createFolder() {
            this.form.folderName = '';
            this.v$.$reset()
            
            document.getElementById('addFolderBtn').click();
            setTimeout(async () =>
                $("#folderName").focus(),
            500);
        }
    },
    setup() {
        return {
            v$: useVuelidate()
        }
    },
    validations() {
        /* const alphaNumeric = helpers.withMessage(
            'Only letters, numbers, spaces, dots, underscores, and hyphens are allowed.',
            helpers.regex(/^[a-zA-Z0-9 ._-]+$/) // added `_` and `-`
        ) */
       const alphaNumeric = helpers.withMessage(
            'Only letters, numbers, spaces, dots, underscores, hyphens, and parentheses are allowed.',
            helpers.regex(/^[a-zA-Z0-9 ._()\--]+$/)
        )
        return {
            form: {
                folderName: {
                    required,
                    alphaNumeric,
                    min: minLength(2)
                }
            },
        }
    },
}
</script>
